import React from 'react';

import classes from '../../../../App.module.css';

const Description = () => {
    const { DescriptionItem } = classes;

    return (
        <div>
            <p className={DescriptionItem}>
                The helper exposes a function which uses{' '}
                <i>ECMAScript Internationalization API</i> behind the scenes in
                order to format the value the user is passing together will all
                the parameterized options explained below.
            </p>
        </div>
    );
};

export default Description;
